// Flat Ground
import { Cartographic } from "cesium";
export class AddPoinToFlatGroundCommand {
    _flatGround;
    _newPointPos;
    _pointID;
    _editCallback;
    constructor(_flatGround, point, editCallback) {
        this._editCallback = editCallback;
        this._flatGround = _flatGround;
        this._newPointPos = point;
    }
    async execute(viewer) {
        this._pointID = await this._flatGround.appendPoint(this._newPointPos);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
    async undo(viewer) {
        await this._flatGround.removePoint(this._pointID);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
}
export class AddPointToFlatGroundAtIndexCommand {
    _flatGround;
    _index;
    _pos;
    _pointID;
    _editCallback;
    constructor(_flatGround, index, point, editCallback) {
        this._editCallback = editCallback;
        this._flatGround = _flatGround;
        this._index = index;
        this._pos = point;
    }
    async execute(viewer) {
        this._pointID = await this._flatGround.appendPointAtIndex(this._index, this._pos);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
    async undo(viewer) {
        await this._flatGround.removePoint(this._pointID);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
}
export class RemovePointFromFlatGroundCommand {
    _flatGround;
    _pos;
    _removedPointID;
    _index;
    _editCallback;
    constructor(flatGround, pointID, editCallback) {
        this._editCallback = editCallback;
        this._flatGround = flatGround;
        this._removedPointID = pointID;
    }
    async execute(viewer) {
        //save the index of point that need's to be removed
        this._index = this._flatGround.getFlatGroundPointIndex(this._removedPointID);
        //save the position of points that need's to be removed
        this._pos = this._flatGround.getFlatGroundPointPos(this._index);
        //remove the point from flatGround
        await this._flatGround.removePoint(this._removedPointID);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
    async undo(viewer) {
        this._removedPointID = await this._flatGround.appendPointAtIndex(this._index, this._pos);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
}
/**
 * Moves all points of flat ground uniformly, also handles undo
 */
export class UpdateAllControlPointHeightCommand {
    _flatGround;
    _heightDifference;
    _oldPositions;
    _editCallback;
    constructor(flatGround, height, editCallback) {
        this._editCallback = editCallback;
        this._flatGround = flatGround;
        this._heightDifference = height;
    }
    async execute() {
        this._oldPositions = this._flatGround.points;
        const newPoints = this._flatGround.points.map((point) => {
            const pointCarto = Cartographic.fromCartesian(point);
            pointCarto.height += this._heightDifference;
            return Cartographic.toCartesian(pointCarto);
        });
        await this._flatGround.updateAllPointsPositions(newPoints);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
    async undo() {
        await this._flatGround.updateAllPointsPositions(this._oldPositions);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
}
export class UpdateFlatGroundPointPositionCommand {
    _flatGround;
    _newPointPos;
    _oldPos;
    _pointID;
    _arrowEntity;
    _editCallback;
    constructor(flatGround, newPos, pointID, arrowEntity, editCallback) {
        this._editCallback = editCallback;
        this._flatGround = flatGround;
        this._newPointPos = newPos;
        this._pointID = pointID;
        this._arrowEntity = arrowEntity;
    }
    async execute(viewer) {
        this._oldPos = await this._flatGround.updateGroundPointPosition(this._newPointPos, this._pointID, this._arrowEntity);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
    async undo(viewer) {
        await this._flatGround.updateGroundPointPosition(this._oldPos, this._pointID, this._arrowEntity);
        this._editCallback &&
            this._editCallback(this._flatGround.id, undefined, false);
    }
}
//# sourceMappingURL=flatground-command.js.map